import { activityLogs } from './activity-logs.query';
import { addendum } from './addendum.query';
import { addendumSession } from './addendum-session.query';
import { aiModelStatus } from './ai-model-status.query';
import { auth } from './auth.query';
import { carePlanNotes } from './care-plan-notes.query';
import { careServiceReportOrgans } from './care-service-report-organs.query';
import { comparison } from './comparison.query';
import { conditionTemplate } from './condition-template.query';
import { documentTypes } from './document-types.query';
import { documents } from './documents.query';
import { findingFromCondition } from './finding-from-condition.query';
import { keyImage } from './key-image.query';
import { omniLlm } from './omni-llm.query';
import { qualityControl } from './quality-control.query';
import { radiologistNote } from './radiologist-note.query';
import { renderedSummary } from './rendered-summary.query';
import { report } from './report.query';
import { reportFinding } from './report-finding.query';
import { reportIssue } from './report-issue.query';
import { reportOrgan } from './report-organ.query';
import { reportPdf } from './report-pdf.query';
import { reportServiceDeskIssue } from './report-service-desk-issue.query';
import { structuredObservation } from './structured-observation.query';
import { urgencyCategory } from './urgency-category.query';
import { userPreference } from './user-preference.query';

export const fct = {
  activityLogs,
  addendum,
  addendumSession,
  aiModelStatus,
  auth,
  carePlanNotes,
  careServiceReportOrgans,
  comparison,
  conditionTemplate,
  documents,
  documentTypes,
  findingFromCondition,
  keyImage,
  omniLlm,
  qualityControl,
  radiologistNote,
  renderedSummary,
  report,
  reportFinding,
  reportIssue,
  reportOrgan,
  reportPdf,
  reportServiceDeskIssue,
  structuredObservation,
  urgencyCategory,
  userPreference,
};
